import type { TestResultsByControlIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetTestResultsByControlIdArgs = { controlId: string };

export const useLazyGetTestResultsByControlId = createLazyQueryHook<
  UseLazyGetTestResultsByControlIdArgs,
  TestResultsByControlIdResponseRow[],
  GetTestResultsByControlIdQuery
>({
  trpcQuery: (client, { controlId }) =>
    client.frontend.testResult.testResultsByControlId.query({ controlId }),
  mapTrpcDataToGraphQL: (data) => ({ test_result: data }),
  graphqlDocument: GetTestResultsByControlIdDocument,
  graphqlVariables: ({ controlId }) => ({ controlId }),
});
